import React, { Component } from 'react'

class WithPopin extends Component {
  state = {
    isOpened: true,
  }

  unblockScroll = () => {
    document.body.style.overflow = 'inherit'
  }

  close = () => {
    this.setState({ isOpened: false })
    this.unblockScroll()
  }

  open = () => {
    this.setState({ isOpened: true })
    document.body.style.overflow = 'hidden' // blocks scrolling
  }

  componentWillUnmount() {
    this.unblockScroll()
  }

  render() {
    return this.props.children({
      popin: {
        ...this.state,
        open: this.open,
        close: this.close,
      }
    })
  }

}

export default (Component) => {
  return function ConfigComponent(props) {
    return (
      <WithPopin>
        {injectProps => <Component {...props} {...injectProps} />}
      </WithPopin>
    )
  }
}
